import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Global numbers composable that provides access to global numbers related state and actions
 */
export function useGlobalNumbers() {
  const store = useStore();

  // Global numbers getters
  const globalNumbers = computed(() => store.getters['globalNumbers/GET_GLOBAL_NUMBERS']);

  // Global numbers actions
  const fetchGlobalNumbers = (confId) => store.dispatch('globalNumbers/fetchGlobalNumbers', confId);
  const fetchGlobalNumbersSGM = (params) => store.dispatch('globalNumbers/fetchGlobalNumbersSGM', params);
  const fetchGlobalNumbersMGM = (params) => store.dispatch('globalNumbers/fetchGlobalNumbersMGM', params);

  return {
    // Getters
    globalNumbers,
    
    // Actions
    fetchGlobalNumbers,
    fetchGlobalNumbersSGM,
    fetchGlobalNumbersMGM,
  };
}
